export default __webpack_public_path__ + "static/media/mlk.39bbf86d.png";